window.cart_free_product = function(){
  if(!window.free_product){
    return;
  }
  fetch("/cart.js").then(res => res.json()).then(cart => {
    var $cart = cart;
    var $items = $cart.items;
    var $cart_items_id = [];
    var $free_qty = 0;

    for(var i = 0; i < $items.length; i++) {
      var $item = $items[i];
      $cart_items_id.push($item.id);
      if($item.id == window.free_product){
        $free_qty += $item.quantity;
      }
     }
    
    if($cart.total_price >= window.free_thresold){
      if (jQuery.inArray(window.free_product, $cart_items_id) != -1) {
        if($free_qty > 1){
          for(var i = 0; i < $items.length; i++) {
            var $item = $items[i];
            if($item.id == window.free_product){
              var formData = new FormData;
                  formData.append("id", $item.key);
                  formData.append("quantity", 1);
                  fetch("/cart/change.js", {
                      method: "POST",
                      body: formData
                  }).then(response => response.text()).then(state => {
                      window.location.reload();
                  });
            }
           }
        }
      } else{
       let formData2 = { items: [] };
        formData2.items.push({ id: window.free_product, quantity: 1 }),
        fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(formData2) })
        .then(response => response.text()).then(state => {
          window.location.reload();
        });
      }
    }else{
      for(var i = 0; i < $items.length; i++) {
        var $item = $items[i];
        if($item.id == window.free_product){
          var formData = new FormData;
              formData.append("id", $item.key);
              formData.append("quantity", 0);
              fetch("/cart/change.js", {
                  method: "POST",
                  body: formData
              }).then(response => response.text()).then(state => {
                  window.location.reload();
              });
        }
       }
    }
  });
}

window.cart_free_product();